(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anoxys-home"] && !Shopify.designMode) return;
  try {
    
function initAnoxysVideo(root) {
  const video = root.querySelector('.ax-hero-media video');
  const toggle = root.querySelector('.ax-video-toggle');
  if (!video || !toggle || toggle.dataset.ready) return;
  toggle.dataset.ready = 'true';
  const sync = () => {
    toggle.textContent = video.paused ? toggle.dataset.play : toggle.dataset.pause;
  };
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
  video.addEventListener('play', sync);
  video.addEventListener('pause', sync);
  toggle.addEventListener('click', () => {
    if (video.paused) video.play().catch(sync);
    else video.pause();
  });
  sync();
}
document.querySelectorAll('.ax-home').forEach(initAnoxysVideo);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('.ax-home').forEach(initAnoxysVideo);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
